import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcologyLeaf = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "ecology-leaf" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.248,21.1a7.532,7.532,0,0,1-7.531-7.532C2.717,2.645,15.861,8.252,22.189,3a.466.466,0,0,1,.479-.048.5.5,0,0,1,.3.378C24.9,14.643,16.572,21.1,10.248,21.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.261,11.554A24.984,24.984,0,0,0,4.652,15.84L.75,19.17"
		})
	]
});
export default SvgEcologyLeaf;
